export default __webpack_public_path__ + "static/media/microbe3.e51391df.png";